<template>
  <!-- Selector of the different tools of the project -->
  <div
    class="miniformcont  black_bg_transparent"
    @click.self="removeSelected()"
  >
    <div class="miniform border_tenth contrast_bg_color">
      <button
        @click="removeSelected()"
        class="close primary_color"
        v-if="titleSelected()"
      >
        <i class="fas fa-times"></i>
      </button>
      <h3 class="primary_color tenth_bg_color">{{ titleSelected() }}</h3>
      <div v-if="selected == 10" class="toolregist">
        <ToolActivityAdd />
      </div>
      <div v-else-if="selected == 11" class="toolregist">
        <ToolActivityEdit />
      </div>
      <div v-else-if="selected == 12" class="toolregist">
        <ToolActivityRead />
      </div>
      <div v-else-if="selected == 13" class="toolregist">
        <ToolEventEdit />
      </div>
      <div v-else-if="selected == 14" class="toolregist">
        <ToolTerms />
      </div>
      <div v-else-if="selected == 15" class="toolregist">
        <ToolEventShare />
      </div>
      <div v-else-if="selected == 16" class="toolregist">
        <ToolProgramAdd />
      </div>
      <div v-else-if="selected == 17" class="toolregist">
        <ToolProgramEdit />
      </div>
      <div v-else-if="selected == 18" class="toolregist">
        <ToolEquipmentAdd />
      </div>
      <div v-else-if="selected == 19" class="toolregist">
        <ToolEquipmentEdit />
      </div>
      <div v-else-if="selected == 20" class="toolregist">
        <ToolActivityBudget />
      </div>
      <div v-else-if="selected == 21" class="toolregist">
        <ToolGenerateMemory />
      </div>
      <div v-else-if="selected == 22" class="toolregist">
        <ToolEventRead />
      </div>
      <div v-if="selected == 40">
        <ToolConfirmDelete />
      </div>
      <div v-if="selected == 41">
        <ToolConfirmEnable />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import ToolActivityAdd from '@/components/ToolActivityAdd.vue'
  import ToolActivityEdit from '@/components/ToolActivityEdit.vue'
  import ToolActivityRead from '@/components/ToolActivityRead.vue'
  import ToolEventEdit from '@/components/ToolEventEdit.vue'
  import ToolEventShare from '@/components/ToolEventShare.vue'
  import ToolTerms from '@/components/ToolTerms.vue'
  import ToolProgramAdd from '@/components/ToolProgramAdd.vue'
  import ToolProgramEdit from '@/components/ToolProgramEdit.vue'
  import ToolEquipmentAdd from '@/components/ToolEquipmentAdd.vue'
  import ToolEquipmentEdit from '@/components/ToolEquipmentEdit.vue'
  import ToolActivityBudget from '@/components/ToolActivityBudget.vue'
  import ToolGenerateMemory from '@/components/ToolGenerateMemory.vue'
  import ToolConfirmDelete from '@/components/ToolConfirmDelete.vue'
  import ToolConfirmEnable from '@/components/ToolConfirmEnable.vue'
  import ToolEventRead from '@/components/ToolEventRead.vue'
  export default {
    name: 'Popup',
    components: {
      ToolActivityAdd,
      ToolActivityEdit,
      ToolTerms,
      ToolActivityRead,
      ToolEventShare,
      ToolEventEdit,
      ToolProgramAdd,
      ToolProgramEdit,
      ToolEquipmentAdd,
      ToolEquipmentEdit,
      ToolActivityBudget,
      ToolGenerateMemory,
      ToolConfirmDelete,
      ToolConfirmEnable,
      ToolEventRead,
    },
    props: {
      selected: {
        type: Number,
        default: 0,
      },
    },

    methods: {
      ...mapActions(['changeToolSelected']),
      titleSelected() {
        let value
        switch (this.selected) {
          case 30:
            value = 'Confirm Code'
            break
          case 31:
            value = 'Add Translation'
            break
        }
        return value
      },
      removeSelected() {
        this.changeToolSelected(null)
      },
    },
  }
</script>

<style scoped>
  .miniformcont {
    top: 0;
    text-align: center;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 15;
  }
  .miniform {
    border-width: 3px;
    border-style: solid;
    border-radius: 10px;
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 90%;
    /* max-height: 950px; */
    height: 100%;
    overflow: hidden;
    overflow-y: scroll;
    scroll-snap-align: center;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .miniform::-webkit-scrollbar {
    display: none;
  }

  .miniform h3 {
    margin: 0px;
  }
  .close {
    float: right;
    position: absolute;
    right: 0;
    top: 4px;
    font-size: 15px;
    height: auto;
    border-color: transparent;
    background-color: #e6e5e5;
  }
  .cont {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
  }
</style>
